import { Colors, Fonts } from '../../../../../shared/theme';
import metrics from '../../../../../shared/theme/metrics';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
    borderRadius: 4,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: '20px',
    height: '56px'
  } as React.CSSProperties,
  imageBox: {
    verticalAlign: 'top',
    display: 'inline-block',
    backgroundColor: '#F8F8F8',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    height: '64px',
    width: '64px'
  },
  image: {
    height: '100%',
    width: '100%'
  },
  menuNameBox: {
    marginLeft: '12px',
    display: 'inline-block',
    width: 'calc(100% - 76px)',
    menuNameText: {
      fontFamily: Fonts.type.KanitRegular,
      fontSize: Fonts.size.text14
    },
    menuDescriptionText: {
      fontFamily: Fonts.type.KanitRegular,
      fontSize: Fonts.size.text12
    }
  },
  paddingBottom20: {
    marginBottom: '20px',
  },
  regularPurple14under: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer',
  },
  regular16fakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack,
  },
  posIcon: {
    width: '7px',
    height: '8px',
    marginRight: '8px'
  },
  medium16fakeBlackTop: {
    fontFamily: Fonts.type.KanitMedium,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack,
    paddingBottom: '20px'
  },
  line: {
    borderWidth: metrics.borderWidth,
    borderBottomWidth: 0,
    borderColor: '#E8E8E8',
    borderStyle: 'solid',
  },
  medium16fakeBlackBottom: {
    fontFamily: Fonts.type.KanitMedium,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack,
    paddingTop: '20px',
  },
  regular14DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray,
    paddingBottom: '20px'
  },
  regular16DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.darkGray,
    paddingBottom: '20px'
  },
  asterisk: {
    width: '6px',
    height: '6px',
    marginLeft: '5px'
  },
  boxButtonStep1: {
    paddingTop: 20,
    paddingLeft: 585
  },
  boxButtonStep2: {
    paddingTop: 20
  },
  boxButtonStep3: {
    paddingTop: 20
  },
  boxButtonStep4: {
    paddingTop: '20px',
    float: 'right'
  },
  buttonFromConfirmGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '180px',
    borderRadius: 5
  },
  buttonFromCancelGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '180px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  marginBottom20: {
    marginBottom: '20px',
  },
  medium16fakeBlack: {
    fontFamily: Fonts.type.KanitMedium,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack
  },
  semiBold20FakeBlack: {
    fontFamily: Fonts.type.KanitSemiBold,
    fontSize: Fonts.size.text20,
    color: Colors.font.primary.fakeBlack,
    marginBottom: metrics.baseMargin / 2
  },
  successIconImage: {
    fontSize: Fonts.size.text70,
    color: Colors.successGreen,
    paddingTop: '45px',
    paddingBottom: '30px'
  },
  calendarInput: {
    width: '250px',
    borderRadius: '4px',
  },
  formText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack,
    paddingTop: '24px'
  },
  calendarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'left'
  }
};

export const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 16 },
};
